import ModuleAlias from './ModuleName'

const constants = {
    userName_is_required: 'UserName is Required',
    userName_is_invalid: 'UserName is Invalid',
    Email_is_required: 'Email Id is Required',
    Email_is_invalid: 'Email Id is Invalid',
    mobile_is_required: 'Mobile is Required',
    mobile_is_invalid: 'Mobile is Invalid',
    Password_is_required: 'Password is Required',
    Password_is_invalid: 'Password is Invalid',
    otp_is_requried: 'OTP is Required',
    otp_is_invalid: 'OTP is Invalid',
    fName_is_requried: 'First Name is Required',
    fName_is_invalid: 'First Name is Invalid',
    fName_is_short: 'First Name is Short',
    lName_is_requried: 'Last Name is Required',
    lName_is_invalid: 'Last Name  is Invalid',
    lName_is_short: 'Last Name  is Short',
    name_is_invalid: 'Name is Invalid',
    name_is_required: 'Name is Required',
    desc_is_required: 'Field is Required',
    desc_is_too_short: 'Field is too Short',
    desc_is_too_long: 'Field is too Long',
    roleId_is_requried: 'Role is Required',
    errorCode_is_requried: 'Error Code is Required',
    errorDesc_is_requried: 'Field is Required',
    errorString_is_requried: 'Error string is Required',
    errorString_is_short: 'Error string is Short',
    errorString_is_long: 'Error string is Long',
    errorString_is_invalid: 'Error string is Invalid',
    Confirm_password_is_required: 'Confirm password is Required',
    Confirm_password_is_invalid: 'Confirm password is Invalid',
    Password_must_be_at_least_8_characters: 'Password must be at least 8 characters',
    name_is_required: 'Name is Required',
    name_is_invalid: 'Name is Invalid',
    desc_is_required: 'All Field is Required',
    desc_is_invalid: 'All Field is Invalid',
    alias: 'Alias is Required',
    alias_is_invalid: 'Alias is Invalid',
    alias_is_short: 'Alias is Short',
    alias_is_long: 'Alias is Long',
    latestVersion_is_requried: 'Latest version is Required',
    minVersion_is_requried: 'Min version is Required',
    isForceUpdate_is_requried: 'Force update is Required',
    isSoftUpdate_is_requried: 'soft update is Required',
    maxDate_is_requried: 'Max Date is Required',
    status_is_required: 'Status is Required',
    apiVersion_is_requried: 'Api Version is Required',
    version_is_invalid: (value) => ` ${value} Version is Invalid`,
    Alias: ModuleAlias
}
export default constants